import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/snackbar/snackbar.component';
import { extractErrorDetails, StructuredError } from 'src/app/shared/utils/error-handler.utils';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private _snackBar: MatSnackBar) { }


  //success snackbar notification
  openSnackBar(snackBarObj: any) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        title: 'Success',
        message: snackBarObj.snackBarMessage,
        iconname: snackBarObj.snackBarIcon,
        isError: false
      },
      duration: snackBarObj.snackBarDuration,
      horizontalPosition: 'end',
    });
  }


  //error snackbar notification
  openErrorSnackBar(snackBarObj: any, error: any) {
    const errorDetails: StructuredError = extractErrorDetails(error, snackBarObj);
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        title: errorDetails.title,
        message: snackBarObj.snackBarMessage, // Original message from snackBarObj
        description: errorDetails.description, // Detailed description from error
        recommendation: errorDetails.recommendation || snackBarObj?.snackBarRecommendation,
        iconname: "error_outline",
        type: errorDetails.type,
        isError: true
      },
      duration: snackBarObj.snackBarDuration || undefined,
      horizontalPosition: 'end',
    });
  }
}